import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-to-active"
export default class extends Controller {
  connect() {
    // Find active element by CSS class instead of Stimulus target
    const active = this.element.querySelector("a.active")?.parentElement
    if (active) {
      // Manually scroll the container to center the active element
      const container = this.element
      const scrollLeft = active.offsetLeft - (container.offsetWidth / 2) + (active.offsetWidth / 2)
      container.scrollLeft = Math.max(0, scrollLeft)
    }
  }
}
